export let life = {
  created () {
    // console.log(this.options)
    this.props.checkStrictly = true
  },
}
export let event = {
  change () {
    this.methods('hideDropDown')
  }
}
export let watch = {}
